export default {
  getProfile (state) {
    return state.profile
  },
  getPermission (state) {
    return state.profile.permissions ? state.profile.permissions : []
  },
  getGroup (state) {
    return state.profile.group ? state.profile.group : {}
  },
  getTotalNotification (state) {
    return state.total_notification
  }
}



// WEBPACK FOOTER //
// ./src/store/module/profile/getters.js